import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export function getUtilityClass(slot: string): string {
  return generateUtilityClass('ModalFooter', slot);
}

export const modalFooterClasses = generateUtilityClasses('ModalFooter', ['root', 'button']);
